// @flow weak

import { sideMenuConst } from "../constants/sideMenuConst";

const initialState = {
  isCollapsed: false,
  time: null
};

export default function sideMenu(state = initialState, action) {
  switch (action.type) {
    case sideMenuConst.GET_SIDE_MENU_TOGGLE_STATE_FROM_LOCALSTORAGE:
      return {
        isCollapsed: Boolean(action.permanentStore.storeValue),
        time: action.time
      };
    case sideMenuConst.OPEN_SIDE_MENU:
      return {
        ...state,
        isCollapsed: action.isCollapsed,
        time: action.time
      };
    case sideMenuConst.CLOSE_SIDE_MENU:
      return {
        ...state,
        isCollapsed: action.isCollapsed,
        time: action.time
      };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/sideMenu.js